const img = require('./ActiveSides.svg'); export default img;